import { modifier } from '@lokalise/louis';
import { css, styled } from '@lokalise/styled';

import { color, spacing, typography } from '@app/theme';

export const IconPlaceholder = styled.div`
    width: 24px;
    height: 24px;
`;

export const StyleGuideModalBody = styled.section`
    display: flex;
    flex-direction: column;
    gap: ${spacing(5)};
`;

export const StyleGuideGrid = styled.section`
    display: flex;
    flex-direction: column;

    & > * {
        border-block-end: 1px solid ${color('border.light')};

        &:last-child {
            border-block-end: none;
        }
    }
`;

export const StyleGuideGridAnimatedRow = styled.div<{ hidden: boolean }>`
    display: grid;
    grid-template-rows: 1fr;
    width: 100%;

    transition: grid-template-rows 200ms ease-in-out 50ms;

    ${modifier(
        'hidden',
        css`
            grid-template-rows: 0fr;
            border-block-end: none !important;

            & > * {
                overflow: hidden;
                transition: padding 200ms ease-in-out 50ms;
                padding-block: 0 !important;
            }
        `,
    )}
`;

export const StyleGuideGridRowWrapper = styled.div`
    display: grid;
    grid-template-columns: auto 1fr 1fr;

    align-items: center;
    gap: ${spacing(2)};
    padding: ${spacing(2)} ${spacing(3)};
`;

export const StyleGuideGridHeaderRow = styled(StyleGuideGridRowWrapper)`
    ${typography('body.small.strong')}
`;
